// 經期狀態入口卡（W58.6 · ADR-0212）—— 雙欄狀態列的**右欄**。
//
// W58.5 的時候它叫 `CycleStrip`，是一個整寬的膠囊，寫著
// 「距離下次經期 18 天 · 易孕期 · 先用預設週期」。W58.6 把它收成一張 44px 的卡，
// **只講一件事**：還有幾天。
//
// **拿掉的兩段字**（理由記在 ADR-0212）：
//
// - `· 黃體期`（`phase_label`）—— 階段由月曆格的**底色**講（`cycleState.ts` 的
//   五種狀態），卡片再寫一次只是雜訊；
// - `· 先用預設週期`（`confidence_label`）—— **降級說明沒有消失**，它搬到狀態列
//   下面單獨一行，而且**只在降級時出現**（`preset` / `partial`）。正常推算時
//   那個欄位是「相當穩定」，把它寫在月曆首頁只是把一個稽核欄位當成裝飾。
//
// **數字從哪裡來。** `days_until_next`（還有幾天）是主；它沒有但有 `cycle_day`
// 時用「經期第 X 天」；兩者都沒有就只寫「經期」—— **不編造數字**，而且這張卡
// 仍然是一個通往週期頁的入口。

import { ChevronRight } from "lucide-react";
import { CycleFlower } from "@/components/calendar/CycleFlower";
import type { CycleProjection } from "@/lib/api/calendar";

export interface CycleStatusCardProps {
  /** 推算投影。`null` = 沒有推算 → 卡片只寫「經期」，仍然可點。 */
  projection: CycleProjection | null;
  /** 進 /calendar/cycle。 */
  onOpen: () => void;
}

export function CycleStatusCard({ projection, onOpen }: CycleStatusCardProps) {
  const days = projection?.days_until_next ?? null;
  const cycleDay = projection?.cycle_day ?? null;
  const label =
    days != null
      ? `經期 ${days} 天後`
      : cycleDay != null
        ? `經期第 ${cycleDay} 天`
        : "經期";

  return (
    <button
      type="button"
      onClick={onOpen}
      data-testid="calendar-cycle-strip"
      aria-label={`${label}，查看週期紀錄`}
      className="press tap-target flex h-11 w-full items-center gap-s-2 rounded-md border border-hairline bg-paper-deep px-s-3 text-left hover:bg-black/5"
    >
      <CycleFlower size={14} aria-hidden="true" className="shrink-0 text-partner-strong" />
      <span className="flex-1 truncate whitespace-nowrap text-meta font-medium text-ink-1">
        {label}
      </span>
      <ChevronRight size={14} aria-hidden="true" className="shrink-0 text-ink-3" />
    </button>
  );
}
